"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _videoLoadingEffect = require("../video-loading-effect");

var _videoLoaderAnimation = _interopRequireDefault(require("./video-loader-animation/video-loader-animation"));

const VideoLoader = ({
  videoTag
}) => {
  const isLoading = (0, _videoLoadingEffect.useVideoLoading)(videoTag);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('video-loader', {
      'video-loader--show': isLoading
    })
  }, /*#__PURE__*/_react.default.createElement(_videoLoaderAnimation.default, null));
};

VideoLoader.propTypes = {
  videoTag: _propTypes.default.instanceOf(global.Element)
};
VideoLoader.defaultProps = {
  videoTag: null
};
var _default = VideoLoader;
exports.default = _default;